import * as React from "react";
import RowUserPage from "./row-user-page";
import AddUserModal from "./add-user-modal";
import { CircularProgress, Dialog, FlatButton } from "material-ui";
import { Constants } from "../../../../constants";
import RedirectIfNotLogged from "../../../menu/redirect-if-not-logged";
import Header from "../../../header";
import TopActionsComponent from "../../../top-actions-component";
import request from "../../../../config/axios-config";
import { connect } from "react-redux";
import * as ErrorAction from "../../../../redux/action/error-action";

class UsersPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      departments: [],
      roles: [],
      positions: [],
      showAdd: false,
      wasDataLoaded: false,
      loadingData: false,
      emptyData: false,
      userPendingDeletion: null,
      deletingUser: false
    };
  }

  componentDidMount() {
    this.refreshData();
  }

  componentWillUnmount() {
    this.setState({ wasDataLoaded: false });
    this.props.hideError();
  }

  onDeleteClicked = (index, id) => {
    const user = this.state.users[index];

    this.setState({
      userPendingDeletion: {
        id,
        email: user ? user.email : ""
      }
    });
    this.props.onDialogVisible(true);
  };

  closeDeleteConfirmation = () => {
    if (!this.state.deletingUser) {
      this.setState({ userPendingDeletion: null });
      this.props.onDialogVisible(false);
    }
  };

  confirmDelete = () => {
    const user = this.state.userPendingDeletion;

    if (!user || this.state.deletingUser) {
      return;
    }

    this.setState({ deletingUser: true });
    request({
      url: Constants.SERVER_ENDPOINT + "/user/delete/" + user.id,
      method: "POST"
    })
      .then(() => {
        this.setState(state => ({
          users: state.users.filter(existingUser => existingUser.id !== user.id),
          wasDataLoaded: true,
          userPendingDeletion: null,
          deletingUser: false
        }));
        this.props.onDialogVisible(false);
      })
      .catch(() => {
        this.props.showError("Stergerea a esuat. Va rog reincercati!");
        this.setState({ deletingUser: false });
      });
  };

  onEditClicked = (
    id,
    firstName,
    middleName,
    lastName,
    email,
    positionId,
    roleId,
    departmentId,
    isActive,
    canSeeAllReports,
    canEditAcquisitionsReports,
    canEditAccountingReports,
    canEditReceptionReports,
    canSeeContracts,
    canSeeApprovedPapers,
    canSeeAllPapers,
    canSeePapersExcelReport,
    signatureLink,
    canSetPaperAsPrinted
  ) => {
    this.setState({
      showEdit: true,
      editId: id,
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      email: email,
      selectedPosition: positionId,
      selectedRole: roleId,
      selectedDepartment: departmentId,
      isActive: isActive,
      editTitle: "Editati utilizatorul",
      addTitle: "Adaugati utilizatorul",
      canSeeAllReports: canSeeAllReports,
      canSeePapersExcelReport: canSeePapersExcelReport,
      canEditAcquisitionsReports: canEditAcquisitionsReports,
      canEditAccountingReports: canEditAccountingReports,
      canEditReceptionReports: canEditReceptionReports,
      canSeeContracts: canSeeContracts,
      canSeeApprovedPapers: canSeeApprovedPapers,
      canSeeAllPapers: canSeeAllPapers,
      signatureLink,
      canSetPaperAsPrinted: canSetPaperAsPrinted
    });
    this.props.onDialogVisible(true);
  };

  onAddClicked = () => {
    this.setState({
      showAdd: true
    });
    this.props.onDialogVisible(true);
  };

  addFinished = () => {
    this.setState({
      showAdd: false
    });
    this.refreshData();
    this.props.onDialogVisible(false);
  };

  editFinished = () => {
    this.setState({
      showEdit: false,
      editId: null
    });
    this.refreshData();
    this.props.onDialogVisible(false);
  };

  refreshData = () => {
    this.setState({ loadingData: true });
    request({
      url: Constants.SERVER_ENDPOINT + "/user/page",
      method: "GET"
    })
      .then(response => {
        let isEmptyData =
          !response.data.users || response.data.users.length === 0;
        this.setState({
          users: response.data.users,
          departments: response.data.departments,
          roles: response.data.roles,
          positions: response.data.positions,
          loadingData: false,
          emptyData: isEmptyData
        });
      })
      .catch(err => {
        this.props.showError("Incarcarea paginii a esuat. Va rog reincercati!");
        this.setState({ loadingData: false });
      });
  };

  render() {
    const deleteDialogActions = [
      <FlatButton
        key="cancel"
        label="Anulează"
        primary
        disabled={this.state.deletingUser}
        onClick={this.closeDeleteConfirmation}
      />,
      <FlatButton
        key="delete"
        label="Șterge"
        secondary
        disabled={this.state.deletingUser}
        onClick={this.confirmDelete}
      />
    ];
    let rows = this.state.users.map((el, i) => {
      return (
        <RowUserPage
          key={el.id}
          id={el.id}
          name={
            el.firstName +
            " " +
            (el.middleName ? el.middleName : "") +
            " " +
            el.lastName
          }
          firstName={el.firstName}
          middleName={el.middleName}
          lastName={el.lastName}
          index={i}
          email={el.email}
          role={el.role ? el.role.name : null}
          roleId={el.role ? el.role.id : null}
          position={el.position ? el.position.name : null}
          positionId={el.position ? el.position.id : null}
          department={el.department ? el.department.name : null}
          departmentId={el.department ? el.department.id : null}
          isActive={el.isActive}
          canSeeAllReports={el.canSeeAllReports}
          canSeePapersExcelReport={el.canSeePapersExcelReport}
          canEditAcquisitionsReports={el.canEditAcquisitionsReports}
          canEditAccountingReports={el.canEditAccountingReports}
          canEditReceptionReports={el.canEditReceptionReports}
          canSeeContracts={el.canSeeContracts}
          canSeeApprovedPapers={el.canSeeApprovedPapers}
          canSeeAllPapers={el.canSeeAllPapers}
          canSetPaperAsPrinted={el.canSetPaperAsPrinted}
          signatureLink={el.signatureLink}
          onDeleteClicked={this.onDeleteClicked}
          onEditClicked={this.onEditClicked}
        />
      );
    });
    return (
      <div>
        <RedirectIfNotLogged />
        <Header title={"Administrare utilizatori"} />

        <Dialog
          title="Confirmați ștergerea"
          actions={deleteDialogActions}
          modal={this.state.deletingUser}
          open={Boolean(this.state.userPendingDeletion)}
          onRequestClose={this.closeDeleteConfirmation}
        >
          Sunteți sigur că doriți să ștergeți utilizatorul
          {this.state.userPendingDeletion &&
          this.state.userPendingDeletion.email ? (
            <strong> {this.state.userPendingDeletion.email}</strong>
          ) : null}
          ? Această acțiune nu poate fi anulată.
        </Dialog>

        {this.state.showAdd === true ? (
          /*Show ADD MODAL*/
          <AddUserModal
            url={this.props.url + "/add/?name="}
            onCancel={this.addFinished}
            title={this.state.addTitle}
            departments={this.state.departments}
            roles={this.state.roles}
            positions={this.state.positions}
            isActive={true}
          />
        ) : (
          ""
        )}

        {this.state.showEdit === true && this.state.editId ? (
          <AddUserModal
            url={this.props.url + "/add/?name="}
            title={this.state.editTitle}
            id={this.state.editId}
            name={this.state.name}
            email={this.state.email}
            firstName={this.state.firstName}
            middleName={this.state.middleName}
            lastName={this.state.lastName}
            selectedPosition={this.state.selectedPosition}
            selectedRole={this.state.selectedRole}
            selectedDepartment={this.state.selectedDepartment}
            isActive={this.state.isActive}
            editTitle={this.state.editTitle}
            departments={this.state.departments}
            roles={this.state.roles}
            positions={this.state.positions}
            isEdit={true}
            canSeeAllReports={this.state.canSeeAllReports}
            canSeePapersExcelReport={this.state.canSeePapersExcelReport}
            canEditAcquisitionsReports={this.state.canEditAcquisitionsReports}
            canEditAccountingReports={this.state.canEditAccountingReports}
            canEditReceptionReports={this.state.canEditReceptionReports}
            canSeeContracts={this.state.canSeeContracts}
            canSeeApprovedPapers={this.state.canSeeApprovedPapers}
            canSeeAllPapers={this.state.canSeeAllPapers}
            signatureLink={this.state.signatureLink}
            onCancel={this.editFinished}
            canSetPaperAsPrinted={this.state.canSetPaperAsPrinted}
          />
        ) : (
          ""
        )}

        {this.state.loadingData ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <div style={{ width: "100%", margin: "0 auto" }}>
              {this.state.emptyData ? (
                <div>
                  <div style={{ float: "right" }}>
                    <TopActionsComponent onAddClicked={this.onAddClicked} />
                  </div>
                  <div style={{ textAlign: "center", marginTop: "50px" }}>
                    <h3>Nu aveti utilizatori!</h3>
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{ float: "right" }}>
                    <TopActionsComponent onAddClicked={this.onAddClicked} />
                  </div>
                  <table className="table  table-hover">
                    <tbody>
                      <tr>
                        <th>Email</th>
                        <th>Nume</th>
                        {/*<th>Functie</th>*/}
                        {/*<th>Rol</th>*/}
                        <th>Compartiment</th>
                        <th>Stare</th>
                        <th>Edit/Delete</th>
                      </tr>
                      {rows}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userDepartment: state.login.user.department
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: text => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPage);
